import { getFirstNumber } from "../../../utils/numberUtils";
import { getSkillsFromCommaSeparatedString } from "../../../utils/stringUtils";

export function AtsJobPostingModal({
  jobOpenings,
  selectedJob,
  setSelectedJob,
  noJobPostingsFound,
  setJobDescription,
  setSelectedATSTitle,
  setSelectedATSID,
  setJobExperience,
  setAtsRequiredSkills,
}) {
  const handleJobSelection = (e) => {
    const selectedJobId = e.target.value;
    setSelectedJob(selectedJobId);

    const selectedJobDetails = jobOpenings.find((job) => job.id === selectedJobId);

    if (selectedJobDetails) {
      setSelectedATSTitle(selectedJobDetails.Posting_Title);
      setJobDescription(selectedJobDetails.Job_Description);
      setJobExperience(getFirstNumber(selectedJobDetails.Work_Experience));
      setSelectedATSID(selectedJobDetails.id);
      setAtsRequiredSkills(getSkillsFromCommaSeparatedString(selectedJobDetails.Required_Skills));
    }
  };

  return (
    <div className="flex flex-col gap-4 px-5 sm:px-14 pt-8 pb-10">
      {noJobPostingsFound && (
        <p className="">No job postings found. Please check your zoho job posting.</p>
      )}

      {!noJobPostingsFound && (
        <div className="flex flex-col gap-3">
          <label className="font-bold">Select the Job</label>
          <select
            value={selectedJob || ""}
            onChange={handleJobSelection}
            className="w-full p-3 border border-gray-600 rounded-md"
          >
            <option value="">Select the job posting</option>
            {Array.isArray(jobOpenings) && jobOpenings.length > 0 ? (
              jobOpenings.map((job) => (
                <option key={job.id} value={job.id}>
                  {job.Posting_Title} - {job.Client_Name.name}
                </option>
              ))
            ) : (
              <option disabled>No job openings available</option>
            )}
          </select>
        </div>
      )}
    </div>
  );
}
